/* global DecompressionStream, CompressionStream */
import  React, {
        useState, 
        useEffect, 
        useRef, 
        }                                   from "react";
import {    useNavigate                 }   from "react-router-dom";        
import { FloatingContainer }                from "components/Container/floatContainer";
import  {  sleep,
        }                                   from "Utilities/utils";   
const styles = {
    desktop: {
        minHeight: "100vh",
        backgroundColor: "#008080",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'MS Sans Serif', Tahoma, Geneva, sans-serif",
        fontSize: "12px",
        color: "#000",
        padding: "24px",
        boxSizing: "border-box",
    },
    window: {
        width: "600px",
        backgroundColor: "#c0c0c0",
        borderTop: "2px solid #ffffff",
        borderLeft: "2px solid #ffffff",
        borderRight: "2px solid #404040",
        borderBottom: "2px solid #404040",
        boxShadow: "1px 1px 0 #000000",
        padding: "2px",
        boxSizing: "border-box",
    },
    titleBar: {
        height: "22px",
        background: "linear-gradient(90deg, #000080, #1084d0)",
        color: "#ffffff",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "2px 3px",
        boxSizing: "border-box",
        fontWeight: "bold",
        userSelect: "none",
    },
    titleLeft: {
        display: "flex",
        alignItems: "center",
        gap: "6px",
        overflow: "hidden",
        whiteSpace: "nowrap",
    },
    icon: {
        width: "16px",
        height: "16px",
        backgroundColor: "#c0c0c0",
        borderTop: "1px solid #ffffff",
        borderLeft: "1px solid #ffffff",
        borderRight: "1px solid #404040",
        borderBottom: "1px solid #404040",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#000080",
        fontSize: "10px",
        lineHeight: "16px",
        boxSizing: "border-box",
    },
    controls: {
        display: "flex",
        alignItems: "center",
        gap: "2px",
    },
    controlButton: {
        width: "18px",
        height: "16px",
        backgroundColor: "#c0c0c0",
        borderTop: "1px solid #ffffff",
        borderLeft: "1px solid #ffffff",
        borderRight: "1px solid #404040",
        borderBottom: "1px solid #404040",
        boxShadow: "inset -1px -1px 0 #808080, inset 1px 1px 0 #dfdfdf",
        color: "#000000",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "12px",
        fontWeight: "bold",
        lineHeight: "1",
        boxSizing: "border-box",
    },
    menuBar: {
        display: "flex",
        gap: "16px",
        padding: "3px 6px 4px",
        borderBottom: "1px solid #808080",
        boxSizing: "border-box",
    },
    menuItem: {
        color: "#000000",
    },
    content: {
        padding: "10px",
        minHeight: "180px",
        backgroundColor: "#c0c0c0",
        boxSizing: "border-box",
    },
    insetPanel: {
        backgroundColor: "#ffffff",
        borderTop: "2px solid #404040",
        borderLeft: "2px solid #404040",
        borderRight: "2px solid #ffffff",
        borderBottom: "2px solid #ffffff",
        padding: "12px",
        minHeight: "96px",
        boxSizing: "border-box",
        marginBottom: "12px",
    },
    heading: {
        margin: "0 0 8px 0",
        fontSize: "14px",
        fontWeight: "bold",
    },
    paragraph: {
        margin: "0 0 8px 0",
        lineHeight: "1.35",
    },
    statusBar: {
        display: "grid",
        gridTemplateColumns: "1fr 120px",
        gap: "4px",
        paddingTop: "4px",
    },
    statusCell: {
        borderTop: "1px solid #808080",
        borderLeft: "1px solid #808080",
        borderRight: "1px solid #ffffff",
        borderBottom: "1px solid #ffffff",
        padding: "3px 6px",
        minHeight: "20px",
        boxSizing: "border-box",
    },
    buttonRow: {
        display: "flex",
        justifyContent: "flex-end",
        gap: "8px",
    },
    button: {
        minWidth: "76px",
        height: "24px",
        backgroundColor: "#c0c0c0",
        borderTop: "2px solid #ffffff",
        borderLeft: "2px solid #ffffff",
        borderRight: "2px solid #404040",
        borderBottom: "2px solid #404040",
        boxShadow: "inset -1px -1px 0 #808080, inset 1px 1px 0 #dfdfdf",
        fontFamily: "'MS Sans Serif', Tahoma, Geneva, sans-serif",
        fontSize: "12px",
        color: "#000000",
        padding: "2px 10px",
        boxSizing: "border-box",
        cursor: "default",
    },
    loadingTrack: {
        backgroundColor: "#ffffff",
        borderTop: "2px solid #404040",
        borderLeft: "2px solid #404040",
        borderRight: "2px solid #ffffff",
        borderBottom: "2px solid #ffffff",
        padding: "2px 3px",
        height: "22px",
        boxSizing: "border-box",
        display: "flex",
        gap: "2px",
        overflow: "hidden",
        position: "relative"
    },
    loadingBlock: {
        width: "8px",
        height: "14px",
        backgroundColor: "#000080",
        flexShrink: 0,
    }    
};
const iconStyle = {
    wrapper: {
        width: "64px",
        height: "64px",
        backgroundColor: "#808080",
        borderTop: "2px solid #bfbfbf",
        borderLeft: "2px solid #bfbfbf",
        borderRight: "2px solid #404040",
        borderBottom: "2px solid #404040",
        padding: "2px",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },

    window: {
        width: "50px",
        height: "50px",
        backgroundColor: "#c0c0c0",
        borderTop: "2px solid #ffffff",
        borderLeft: "2px solid #ffffff",
        borderRight: "2px solid #404040",
        borderBottom: "2px solid #404040",
        boxSizing: "border-box",
        padding: "4px",
    },

    titleBar: {
        height: "12px",
        backgroundColor: "#0000c0",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: "4px",
        paddingRight: "4px",
        boxSizing: "border-box",
    },

    titleButton: {
        width: "4px",
        height: "4px",
        backgroundColor: "#c0c0c0",
    },

    body: {
        marginTop: "4px",
        height: "20px",
        backgroundColor: "#ffffff",
        borderTop: "2px solid #808080",
        borderLeft: "2px solid #808080",
        boxSizing: "border-box",
    },
};        
async function compressContent(obj) {
    const json = JSON.stringify(obj);

    const stream = new Blob([json]).stream()
        .pipeThrough(new CompressionStream('gzip'));

    const compressedBuffer = await new Response(stream).arrayBuffer();

    return btoa(
        String.fromCharCode(...new Uint8Array(compressedBuffer))
    );
}
async function Generic_Call(sys_body) 
{
    const baseURL = `${process.env.REACT_APP_API_BASE_URL}/${sys_body.Endpoint}`;

    try {        
        const server_response = await fetch(baseURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(sys_body)
        });
        if (!server_response.ok) {
            throw new Error(`HTTP error! Status: ${server_response.status}`);
        }

        return await server_response.json();
    } 
    catch (error) {
        console.error('Fetch error:', error);
        return {};
    }
}
const HandleInstall = async (v, success) => {
    try {
        const default_payload = {
            Endpoint: "setup",
            Charlore: null,
            Tolkien: null,
            Compressed: true,
            Content: await compressContent(v),
        };
        const payload = await Generic_Call(default_payload);
        
        if (payload?.Status?.Code === 0) {
            await success();
        }
        else {
            await success();
        }
    } catch (error) {
        console.error(error);
    }
};
const Windows95SetupIcon = ({action}) => {
    return (
        <FloatingContainer
            Visible={true}
            Coordinate={{
                x: 500,
                y: 500,
            }}
            Draggable={true}
            StackPosition={0}
        >
            <div onClick={action} style={iconStyle.wrapper}>
                <div style={iconStyle.window}>
                    <div style={iconStyle.titleBar}>
                        <div style={iconStyle.titleButton} />
                        <div style={iconStyle.titleButton} />
                        <div style={iconStyle.titleButton} />
                    </div>
                    <div style={iconStyle.body} />
                </div>
            </div>
            <div style={{color: "black", marginTop: "5px"}}>
                _Setup.exe
            </div>
        </FloatingContainer>
    );
};
const FirstDisclaimerContent = ({process, actions}) => {
    return(
        <React.Fragment>
            <div style={styles.insetPanel}>
                <div style={{overflow: "scroll", height: "250px"}}>
                <div style={styles.heading}>Software Installation Agreement of Totally Serious Importance</div>
                    <div style={styles.paragraph}>
                        Welcome to the installation process for this software, a carefully assembled collection of buttons, pixels, promises, and mysterious background operations that may or may not improve your day.
                    </div>
                    <div style={styles.paragraph}>
                        Before continuing, please read this disclaimer with the same level of attention you normally give to software agreements, which is to say: scroll confidently, pretend you understood everything, and click the button that allows you to move on with your life.
                    </div>
                    <div style={styles.paragraph}>
                        By installing this software, you acknowledge that it may occasionally ask for your feedback. This feedback may include your opinions, complaints, compliments, confused noises, emotional damage reports, and highly detailed explanations of why a button should be three pixels to the left.
                    </div>
                    <div style={styles.paragraph}>
                        ISE Systems Corporation may use your feedback to improve the software, organize priorities, create charts, generate internal discussions, and give developers a reason to stare silently at their monitors for several minutes.
                    </div>
                    <div style={styles.paragraph}>
                        You understand that your feedback is valuable. Very valuable. Suspiciously valuable. In fact, some experts believe that one well-written feedback message can save a product team from weeks of guessing, arguing, and saying “maybe users won’t notice.”
                    </div>
                    <div style={styles.paragraph}>
                        Please note that submitting feedback does not guarantee that your suggestion will be implemented immediately, soon, ever, or in this dimension. However, it may be respectfully added to a backlog, where it will live peacefully among other ideas with names like “Improve onboarding flow” and “Fix weird thing on settings page.”
                    </div>
                    <div style={styles.paragraph}>
                        You also agree not to blame the software for problems caused by spilled coffee, ancient operating systems, cursed keyboards, aggressive clicking, cosmic rays, or that one coworker who says “it works on my machine.”
                    </div>
                    <div style={styles.paragraph}>
                        Some features may behave unexpectedly. This is not a bug. It is an opportunity for growth. For you. For us. For everyone involved.
                    </div>
                    <div style={styles.paragraph}>
                        By continuing, you confirm that you are mentally prepared to install this software, provide feedback when requested, and participate in the noble cycle of clicking, testing, reporting, waiting, updating, and clicking again.
                    </div>
                    <div style={styles.paragraph}>
                        Near the end of this agreement, where only the bravest readers remain, we must inform you that by accepting this, you will give a small, symbolic, legally non-binding, emotionally questionable part of your life to ISE Systems Corporation.
                    </div>
                    <div style={styles.paragraph}>
                        This portion of your life may be used to improve user experience, refine system behavior, support product decisions, and power the sacred corporate machine known internally as “continuous improvement.”
                    </div>
                    <div style={styles.paragraph}>
                        No actual souls, pets, houseplants, memories, browser bookmarks, or lunch breaks will be collected as part of this agreement. Unless otherwise stated in a future update, which you also probably will not read.
                    </div>
                    <div style={styles.paragraph}>
                        By clicking Accept, you agree to proceed with the installation, share feedback when appropriate, and accept that somewhere, somehow, an engineer may read your comment and whisper: “Actually, that’s a good point.”
                    </div>                                    
                    <div style={styles.paragraph}>
                        Click Accept to continue.
                    </div>
                    <div style={styles.paragraph}>
                        Click Cancel to preserve your remaining innocence.
                    </div>
                </div>
            </div>            
            <div style={styles.buttonRow}>
                <button onClick={actions.accept} style={styles.button}>
                    OK
                </button>

                <button onClick={actions.cancel} style={styles.button}>
                    Cancel
                </button>
            </div>
            <div style={styles.statusBar}>
                <div style={styles.statusCell}>ISE Systems Corporation</div>
                <div style={styles.statusCell}>Install</div>
            </div>
        </React.Fragment>
    );
}
const SecondDisclaimerContent = ({process, actions}) => {
    return(
        <React.Fragment>
            <div style={styles.insetPanel}>
                <div style={{overflow: "scroll", height: "250px"}}>
                    <div style={styles.heading}>
                        After all you read you really want to proceed?
                    </div>
                    <div style={styles.heading}>
                        You don't want to read again?
                    </div>              
                    <div style={styles.heading}>
                        OK read again, last chance to change your mind!
                    </div>                                        
                    <div style={styles.paragraph}>
                        Welcome to the installation process for this software, a carefully assembled collection of buttons, pixels, promises, and mysterious background operations that may or may not improve your day.
                    </div>
                    <div style={styles.paragraph}>
                        Before continuing, please read this disclaimer with the same level of attention you normally give to software agreements, which is to say: scroll confidently, pretend you understood everything, and click the button that allows you to move on with your life.
                    </div>
                    <div style={styles.paragraph}>
                        By installing this software, you acknowledge that it may occasionally ask for your feedback. This feedback may include your opinions, complaints, compliments, confused noises, emotional damage reports, and highly detailed explanations of why a button should be three pixels to the left.
                    </div>
                    <div style={styles.paragraph}>
                        ISE Systems Corporation may use your feedback to improve the software, organize priorities, create charts, generate internal discussions, and give developers a reason to stare silently at their monitors for several minutes.
                    </div>
                    <div style={styles.paragraph}>
                        You understand that your feedback is valuable. Very valuable. Suspiciously valuable. In fact, some experts believe that one well-written feedback message can save a product team from weeks of guessing, arguing, and saying “maybe users won’t notice.”
                    </div>
                    <div style={styles.paragraph}>
                        Please note that submitting feedback does not guarantee that your suggestion will be implemented immediately, soon, ever, or in this dimension. However, it may be respectfully added to a backlog, where it will live peacefully among other ideas with names like “Improve onboarding flow” and “Fix weird thing on settings page.”
                    </div>
                    <div style={styles.paragraph}>
                        You also agree not to blame the software for problems caused by spilled coffee, ancient operating systems, cursed keyboards, aggressive clicking, cosmic rays, or that one coworker who says “it works on my machine.”
                    </div>
                    <div style={styles.paragraph}>
                        Some features may behave unexpectedly. This is not a bug. It is an opportunity for growth. For you. For us. For everyone involved.
                    </div>
                    <div style={styles.paragraph}>
                        By continuing, you confirm that you are mentally prepared to install this software, provide feedback when requested, and participate in the noble cycle of clicking, testing, reporting, waiting, updating, and clicking again.
                    </div>
                    <div style={styles.paragraph}>
                        Near the end of this agreement, where only the bravest readers remain, we must inform you that by accepting this, you will give a small, symbolic, legally non-binding, emotionally questionable part of your life to ISE Systems Corporation.
                    </div>
                    <div style={styles.paragraph}>
                        This portion of your life may be used to improve user experience, refine system behavior, support product decisions, and power the sacred corporate machine known internally as “continuous improvement.”
                    </div>
                    <div style={styles.paragraph}>
                        No actual souls, pets, houseplants, memories, browser bookmarks, or lunch breaks will be collected as part of this agreement. Unless otherwise stated in a future update, which you also probably will not read.
                    </div>
                    <div style={styles.heading}>
                        Relax I can't ask for your soul, its to Gigatech to ask for your life, but maybe i can ask for cookies.
                    </div>                    
                    <div style={styles.heading}>
                        Not too much.
                    </div>                                        
                    <div style={styles.heading}>
                        Just a bunch of chocolate chips cookies and milk.
                    </div>          
                    <div style={styles.heading}>
                        Just like Santa.
                    </div>            
                    <div style={styles.heading}>
                        Everybody likes Santa...
                    </div>                                                  
                    <div style={styles.heading}>
                        Sorry just continue with the blablabla that nobody reads.
                    </div>                                                                                
                    <div style={styles.paragraph}>
                        By clicking Accept, you agree to proceed with the installation, share feedback when appropriate, and accept that somewhere, somehow, an engineer may read your comment and whisper: “Actually, that’s a good point.”
                    </div>                                    
                    <div style={styles.paragraph}>
                        Click Accept to continue.
                    </div>
                    <div style={styles.paragraph}>
                        Click Cancel to preserve your remaining innocence.
                    </div>
                    <div style={styles.heading}>
                        Remember this is your last chance to change your mind!
                    </div>
                </div>
            </div>            
            <div style={styles.buttonRow}>
                <button onClick={actions.accept} style={styles.button}>
                    OK
                </button>

                <button onClick={actions.cancel} style={styles.button}>
                    Cancel
                </button>
            </div>
            <div style={styles.statusBar}>
                <div style={styles.statusCell}>ISE Systems Corporation</div>
                <div style={styles.statusCell}>Install</div>
            </div>
        </React.Fragment>
    );
}
const Loading = ({ actions }) => {
    const [blocks, setBlocks] = useState([]);
    const trackRef = useRef(null);

    useEffect(() => {
        const interval = setInterval(() => {
            if (!trackRef.current) return;
            const trackWidth = trackRef.current.clientWidth - 6; 
            const blockWidthWithGap = 10;
            const maxBlocks = Math.floor(trackWidth / blockWidthWithGap);

            setBlocks((prevBlocks) => {
                if (prevBlocks.length >= maxBlocks) {
                    return [];
                }
                return [...prevBlocks, prevBlocks.length];
            });
        }, 150);

        return () => clearInterval(interval);
    }, []);

    return (
        <React.Fragment>
            <div style={styles.insetPanel}>
                <div style={styles.heading}>Installing Components...</div>
                <div style={{ ...styles.paragraph, marginBottom: "16px" }}>
                    Please wait while Setup copies files, updates system configurations, and eats a plate of chocolate chip cookies.
                </div>
                <div style={{ ...styles.paragraph, marginTop: "8px", color: "#404040", fontStyle: "italic" }}>
                    Conclusion: maybe 1 of 212 years
                </div>
                <div ref={trackRef} style={styles.loadingTrack}>
                    {blocks.map((id) => (
                        <div key={id} style={styles.loadingBlock} />
                    ))}
                </div>
                
                <div style={{ ...styles.paragraph, marginTop: "8px", color: "#404040", fontStyle: "italic" }}>
                    Extracting: blablabla.dll...
                </div>
            </div>            
            
            <div style={styles.buttonRow}>
                <button 
                    disabled 
                    style={{ ...styles.button, opacity: 0.6, color: "#808080", cursor: "not-allowed" }}
                >
                    OK
                </button>

                <button onClick={actions?.cancel} style={styles.button}>
                    Cancel
                </button>
            </div>
            
            <div style={styles.statusBar}>
                <div style={styles.statusCell}>ISE Systems Corporation</div>
                <div style={styles.statusCell}>Copying files...</div>
            </div>
        </React.Fragment>
    );
};
const Success = ({ actions }) => {
    return (
        <React.Fragment>
            <div style={styles.insetPanel}>
                <div style={styles.heading}>Installation completed!</div>
                <div style={{ ...styles.paragraph, marginBottom: "16px" }}>
                    Enjoy FeedBack application!
                </div>
                <div style={{ ...styles.paragraph, marginBottom: "16px" }}>
                    This program was made by JCM in tribute for LFO
                </div>                
            </div>            
            
            <div style={styles.buttonRow}>
                <button 
                    disabled 
                    style={{ ...styles.button, opacity: 0.6, color: "#808080", cursor: "not-allowed" }}
                >
                    OK
                </button>

                <button onClick={actions?.cancel} style={styles.button}>
                    Cancel
                </button>
            </div>
            
            <div style={styles.statusBar}>
                <div style={styles.statusCell}>ISE Systems Corporation</div>
                <div style={styles.statusCell}>Copying files...</div>
            </div>
        </React.Fragment>
    );
};
const FormContent = ({process, actions}) => {
    const [userStack, setUserStack ] = useState([
        {
            Email:"",
            FirstName:"",
            LastName:"",
            ModuleName:"A",
            StatusId: 1,
        },
        {
            Email:"",
            FirstName:"",
            LastName:"",
            ModuleName:"B",
            StatusId: 1,
        },
    ]);

    const handleChange = (key, idx, value) => {
        setUserStack(prev => 
            prev.map((entry, i) =>
                i === idx ?   
                    {
                        ...entry,
                        [key]: value
                    }
                : 
                    entry
            )
        );
    };

    return(
        <React.Fragment>
            <div>
                <div style={{height: "500px", width: "500px"}}>
                    <div style={styles.heading}>
                        You are here? Uow such a courage user, you deserve this software
                    </div>
                    <div style={styles.paragraph}>
                        This is the data releated to the rector of the organization, the C level, but its not the language.
                    </div>              
                    <div style={styles.paragraph}>
                        It's like the version of Mush of Texta, the man on blue suit in a big chair.
                    </div>                                  
                    <div style={styles.paragraph}>
                        Email:
                    </div>                                  
                    <input onChange={(e) => {handleChange("Email", 0, e.target.value);}}/>
                    <div style={styles.paragraph}>
                        First name:
                    </div>              
                    <input onChange={(e) => {handleChange("FirstName", 0, e.target.value);}}/>
                    <div style={styles.paragraph}>
                        Last name:
                    </div>              
                    <input onChange={(e) => {handleChange("LastName", 0, e.target.value);}}/>
                    <div style={styles.paragraph}>
                        Now its the person responsible for the people organization, you see i'm talking to you a machine that represents how much you are important to me!
                    </div>              
                    <div style={styles.paragraph}>
                        Without you i never exist in the first place, you hired me.
                    </div>                                  
                    <div style={styles.paragraph}>
                        Email:
                    </div>                                  
                    <input onChange={(e) => {handleChange("Email", 1, e.target.value);}}/>
                    <div style={styles.paragraph}>
                        First name:
                    </div>              
                    <input onChange={(e) => {handleChange("FirstName", 1, e.target.value);}}/>
                    <div style={styles.paragraph}>
                        Last name:
                    </div>              
                    <input onChange={(e) => {handleChange("LastName", 1, e.target.value);}}/>
                </div>
            </div>            
            <div style={styles.buttonRow}>
                <button onClick={() => {actions.run(userStack)}}style={styles.button}>OK</button>
                <button onClick={actions.cancel} style={styles.button}>Cancel</button>
            </div>
            <div style={styles.statusBar}>
                <div style={styles.statusCell}>ISE Systems Corporation</div>
                <div style={styles.statusCell}>Install</div>
            </div>
        </React.Fragment>
    );
};

const WindowSetup = ({ children, process, actions }) => {
    return (
        <FloatingContainer
            Visible={true}
            Coordinate={{
                x: process?.coordinates?.x,
                y: process?.coordinates?.y,
            }}
            Draggable={true}
            StackPosition={process?.coordinates?.z}
        >
            <div style={styles.window}>
                <div style={styles.titleBar}>
                    <div style={styles.titleLeft}>
                        <div style={styles.icon}>▣</div>
                        <div>_FeedBackSetupWizard.exe</div>
                    </div>

                    <div style={styles.controls}>
                        <div style={styles.controlButton}>_</div>
                        <div style={styles.controlButton}>□</div>
                        <div
                            onClick={actions.close}
                            style={styles.controlButton}
                        >
                            ×
                        </div>
                    </div>
                </div>

                <div style={styles.menuBar}>
                    <div style={styles.menuItem}>File</div>
                    <div style={styles.menuItem}>Edit</div>
                    <div style={styles.menuItem}>View</div>
                    <div style={styles.menuItem}>Help</div>
                </div>

                <div style={styles.content}>
                    {children}
                </div>
            </div>
        </FloatingContainer>
    );
};

const ApplicationMap = {
    FirstDisclaimerContent: {
        Component: FirstDisclaimerContent,
        actions: ({ close, open, process }) => ({
            close: () => close(process.index),
            accept: () => open("SecondDisclaimerContent"),
            cancel: () => close(process.index),
        }),
    },
    SecondDisclaimerContent: {
        Component: SecondDisclaimerContent,
        actions: ({ close, open, process }) => ({
            close: () => close(process.index),
            accept: () => open("FormContent"),
            cancel: () => open("FirstDisclaimerContent"),
        }),
    },
    FormContent: {
        Component: FormContent,
        actions: ({ close, open, process, run }) => ({
            close: () => close(process.index),
            run: (userStack) => run(userStack),
            cancel: () => close(process.index),
        }),
    },    
    Loading: {
        Component: Loading, 
        actions: ({ close, process }) => ({
            close: () => close(process.index),
            cancel: () => close(process.index),
        }),
    },
    Success: {
        Component: Success, 
        actions: ({ close, process }) => ({
            close: () => close(process.index),
            cancel: () => close(process.index),
        }),
    }        
};

export const Windows95 = () => {
    const [stack, setStack] = useState(() => []);
    const navigate = useNavigate();

    const handleClose = (index) => {
        setStack((prev) => prev.filter((p) => p.index !== index));
    };

    const handleOpen = (key) => {
        setStack((prev) => [
            ...prev,
            {
                key,
                index: Date.now(),
                coordinates: {
                    x: Math.random() * 600,
                    y: Math.random() * 400,
                    z: prev.length + 1,
                },
            },
        ]);
    };

    const handleRun = async (userStack) => {
        handleOpen("Loading");
        try {
            await HandleInstall(
                userStack,
                async () => {
                    await sleep(9000);
                    setStack(prev => prev.filter(p => p.key !== "Loading"));

                    handleOpen("Success");

                    await sleep(20000);

                    navigate("/");
                }
            );
        } 
        catch (error) {
            console.error("Installation failed", error);
        }
    };

    return (
        <div style={styles.desktop}>
            {stack.map((process) => {
                const app = ApplicationMap[process.key];
                const Content = app.Component;

                const actions = app.actions({
                    close: handleClose,
                    open: handleOpen,
                    run: handleRun,
                    process,
                });

                return (
                    <WindowSetup
                        key={process.index}
                        process={process}
                        actions={actions}
                    >
                        <Content
                            process={process}
                            actions={actions}
                        />
                    </WindowSetup>
                );
            })}
            <Windows95SetupIcon action={() => {handleOpen("FirstDisclaimerContent")}}/>
        </div>
    );
};